import { render } from "./AdyenBlikForm.vue?vue&type=template&id=747e0676"
import script from "./AdyenBlikForm.vue?vue&type=script&lang=js"
export * from "./AdyenBlikForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__